import InvoiceListPanel from '@/pages/dashboard/finance/components/InvoiceListPanel';

export default function FinanceDevisPage() {
  return <InvoiceListPanel docType="quote" />;
}